export const DEFAULT_CURRENCY_CODE = 'USD';
export const DEFAULT_LOCALE = 'en';
export function currencyFormat({ locale = DEFAULT_LOCALE, currency = DEFAULT_CURRENCY_CODE, }) {
    const Intl = typeof window === 'undefined' ? null : window.Intl;
    return Intl
        ? new Intl.NumberFormat(locale.replace('_', '-'), {
            style: 'currency',
            currency,
        }).format
        : fallback(currency);
}
const fallback = (currency) => (amount) => `${currency}${amount}`;
//# sourceMappingURL=currency-format.js.map